// Hoisted formatter — Intl.DateTimeFormat is expensive to construct; reused across calls.
const ADMIN_DATE_TIME_FMT = new Intl.DateTimeFormat('es-MX', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatIsoDate(
  iso: string | null | undefined,
  monthFormat: 'short' | 'long' = 'short',
): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-MX', {
    year: 'numeric',
    month: monthFormat,
    day: 'numeric',
  });
}

/**
 * Formatea una fecha a formato largo con hora (es-ES)
 * Ej: 14 de enero de 2026, 11:56
 */
export function formatDateLong(date: Date): string {
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Formats an ISO date string for admin UI display (dd mmm yyyy, hh:mm).
 * Accepts null/undefined — returns `fallback` (default '—').
 */
export function formatAdminDateTime(dateStr: string | null | undefined, fallback = '—'): string {
  if (!dateStr) return fallback;
  return ADMIN_DATE_TIME_FMT.format(new Date(dateStr));
}
